module.exports = __webpack_public_path__ + "img/大石.965392be.png";